import { useTranslation } from 'react-i18next';
import { Flex } from '@amzn/storm-ui';
import { Form } from '@amzn/storm-ui-column-form-kit';
import { CustomCard } from '../../../UiComponentsLibrary/CustomCard';
import { CustomButton } from '../../../UiComponentsLibrary/CustomButton';
import FormInputField from '../../../Shared/components/FormInputField';
import DatePickerWrapper from '../../../Shared/components/CreateArtEventForm/DatePickerWrapper';
import { WaitlistToggleField } from '../../../Shared/components/WaitlistToggleField';
import { useEditArtEventForm } from '../../hooks/useEditArtEventForm';
import { ArtEventInterface } from '../../interfaces/editArtEventInterfaces';
import { datePickerConfigs } from '../../../Shared/components/CreateArtEventForm/constants/configs';
import { FORM_BUTTONS } from '../../config/formButtonsConfig';

interface EditArtEventFormProps {
  artEvent: ArtEventInterface;
  onClose: () => void;
  onSuccess: (message: string) => void;
  onError?: (message: string) => void;
  waitlistFeatureEnabled?: boolean;
}

const EditArtEventForm = ({
  artEvent,
  onClose,
  onSuccess,
  onError,
  waitlistFeatureEnabled = false,
}: EditArtEventFormProps) => {
  const { t } = useTranslation();
  const {
    dateProps,
    buttonProps: { handleSubmit, handleCancel },
    waitlistProps: { waitlistEnabled, isWaitlistLocked, handleWaitlistToggle },
    validationErrors,
  } = useEditArtEventForm(artEvent, onClose, onSuccess, onError);

  const buttonHandlers = {
    cancel: handleCancel,
    submit: handleSubmit,
  };

  return (
    <CustomCard id="edit-art-event-card" title={t('edit-art-event-form-title')}>
      <Form id="edit-art-event-form">
        <FormInputField
          id="art-event-name"
          label={t('art-event-name-label')}
          value={artEvent.artEventID}
          disabled
        />
        {datePickerConfigs.map((config, index) => (
          <DatePickerWrapper
            key={config.id}
            config={config}
            index={index}
            {...dateProps}
            validationErrors={validationErrors}
          />
        ))}
        <FormInputField
          id="art-event-status"
          label={t('status-label')}
          value={artEvent.status}
          disabled
        />
        {waitlistFeatureEnabled && (
          <WaitlistToggleField
            id="art-event-waitlist-toggle"
            enabled={waitlistEnabled}
            isLocked={isWaitlistLocked}
            onToggle={/* istanbul ignore next */ () => handleWaitlistToggle()}
          />
        )}
      </Form>
      <Flex justifyContent="flex-end" padding="xsmall" columnGap="small">
        {FORM_BUTTONS.map((button) => (
          <CustomButton
            key={button.id}
            id={button.id}
            text={t(button.textKey)}
            backgroundColor={button.backgroundColor}
            handleOnClickCb={buttonHandlers[button.action]}
          />
        ))}
      </Flex>
    </CustomCard>
  );
};

export default EditArtEventForm;
